export enum SurveyStatusType {
	Draft = 1,
	SchedulingInProgress = 2,
	Scheduled = 3,
	Failed = 4,
	SurveyInProgress = 5,
	SurveyClosed = 6,
	Cancelled = 7,
	PublicSurveyTemplate = 8,
	DeletingInProgress = 9,
	ClosingInProgress = 10,
	SurveyCloseFailed = 11,
}
